//@ts-nocheck
import { getRevisionsByFieldInstance } from "db/queries/revisionQueries";
import getTableFields from "./getTableFields";

/**
 * Handles deleting all the field instances and their children (table)
 * @param {Array} fieldInstances the field instances to delete
 * @param {boolean} deleteAlts to determine if the alt instances should be deleted or not.
 * @param {boolean} online Whether or not the user is online
 * @returns the array of field instance ids to delete.
 */
async function prepareFieldInstanceDataForDelete(fieldInstances, deleteAlts, online) {
	let final = [];
	let images = [];

	// This thing is an array of arrays.  Each element is the revisions for one field, which is a list.
	const revisionPromises = [];
	// This will be the resolved and flattened version of the previous array.
	let finalRevisions = [];
	let deletedAlts = {};
	for (let i = 0; i < fieldInstances.length; i++) {
		const fieldInstance = fieldInstances[i];
		if (fieldInstance.fieldTemplate?.tableField) {
			// table fields will be handled separatley since they could need pagination.
			continue;
		}
		// some fields have tableFields
		if (fieldInstance.fieldTemplate && (fieldInstance.fieldTemplate.inputType === "table" || fieldInstance.fieldTemplate.inputType === "imageroll")) {
			const tableFields = await getTableFields(fieldInstance.id, online);
			// its a table field instance
			for (let j = 0; j < tableFields.length; j++) {
				const tableField = tableFields[j];
				final.push({ id: tableField.id });
				if (tableField.fieldTemplate?.inputType === "image") {
					// add image to images to delete
					images.push(tableField.image);
				}
				// const tableFieldsRevisionsPromise = getRevisionsByFieldInstance(tableField.id, online);
				// revisionPromises.push(tableFieldsRevisionsPromise);
			}
		}

		if (fieldInstance.altInstanceId && !deletedAlts[fieldInstance.altInstanceId] && deleteAlts) {
			final.push({ id: fieldInstance.altInstanceId });
			deletedAlts[fieldInstance.altInstanceId] = true;
			// const altInstanceRevisionsPromise = getRevisionsByFieldInstance(fieldInstance.altInstanceId, online);
			// revisionPromises.push(altInstanceRevisionsPromise);
		}

		final.push({ id: fieldInstance.id });

		if (fieldInstance.fieldTemplate?.inputType === "image") {
			// add image to images to delete
			images.push(fieldInstance.image);
		}

		// const fieldsRevisionsPromise = getRevisionsByFieldInstance(fieldInstance.id, online);
		// revisionPromises.push(fieldsRevisionsPromise);
	}

	const resolvedRevisions = await Promise.all(revisionPromises);
	// Now just need to go through all the revisions and put the id in the finalRevisions array and flatten
	for (let i = 0; i < resolvedRevisions.length; i++) {
		const oneFieldsRevisions = resolvedRevisions[i];

		for (let ii = 0; ii < oneFieldsRevisions.length; ii++) {
			const revision = oneFieldsRevisions[ii];
			finalRevisions.push(revision.id);
		}
	}
	const finalObj = {
		fieldInstances: final,
		revisions: finalRevisions,
		images,
	};
	return finalObj;
}

export default prepareFieldInstanceDataForDelete;
